export const GET_DASHBOARD_REQUEST = "GET_DASHBOARD_REQUEST"
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS"
export const CREATE_DASHBOARD_MENU_REQUEST = "CREATE_DASHBOARD_MENU_REQUEST"
export const CREATE_DASHBOARD_MENU_SUCCESS = "CREATE_DASHBOARD_MENU_SUCCESS"
export const GET_DASHBOARD_MENU_REQUEST = "GET_DASHBOARD_MENU_REQUEST"
export const GET_DASHBOARD_MENU_SUCCESS = "GET_DASHBOARD_MENU_SUCCESS"
export const DELETE_DASHBOARD_MENU_REQUEST = "DELETE_DASHBOARD_MENU_REQUEST"
export const DELETE_DASHBOARD_MENU_SUCCESS = "DELETE_DASHBOARD_MENU_SUCCESS"